import { Box, Typography } from "@mui/material";

const styles = {
  footer: {
    px: "1rem",
    py: "1rem",
    textAlign: "center",
    backgroundColor: "primary.main",
    color: "secondary.contrastText",
  },
};

function Footer() {
  return (
    <>
      <Box position={"relative"}>
        <Box className="ocean">
          <Box className="wave"></Box>
          <Box className="wave"></Box>
          <Box className="wave"></Box>
        </Box>
      </Box>
      <Box component="footer" sx={styles.footer}>
        <Typography variant="body1" fontWeight="bold">
          © {new Date().getFullYear()} ZavalGT
        </Typography>
      </Box>
    </>
  );
}

export default Footer;
